var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M4.888 16c-.104 0-.208-.035-.312-.07-.243-.138-.416-.38-.416-.658v-3.779c0-.173.07-.346.173-.485l5.2-5.72c.277-.312.728-.312 1.04-.034.312.277.312.728.035 1.04L5.616 11.77v2.045l2.912-2.184a.834.834 0 0 1 .693-.104l1.837.728 1.56-10.226-10.4 5.789 1.665.97a.73.73 0 1 1-.763 1.248L.347 8.408A.696.696 0 0 1 0 7.784c0-.277.139-.485.381-.624L13.208.088a.75.75 0 0 1 .762.035.707.707 0 0 1 .312.693L12.342 13.4a.785.785 0 0 1-.348.52.66.66 0 0 1-.624.035l-2.322-.936-3.744 2.808a.574.574 0 0 1-.416.173z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#8A8E96",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1 0h16v16H-1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.32f30f58745c073754fd5c4a7a09fc6b.svg";
export { ForwardRef as ReactComponent };